import type { App } from 'vue';
import { isE2ETest, isProd } from './EnvUtils';

function checkOverlayAvailable() {
  // must be within function call because that's when the element is defined for sure.
  const ErrorOverlay = customElements.get('vite-error-overlay');
  // don't open outside vite environment
  return !!ErrorOverlay;
}

// REGISTER ERROR OVERLAY
function showErrorOverlay(err: any) {
  // must be within function call because that's when the element is defined for sure.
  const ErrorOverlay = customElements.get('vite-error-overlay');
  // don't open outside vite environment
  if (!ErrorOverlay) { return; }
  const overlay = new ErrorOverlay(err);
  document.body.appendChild(overlay);
}

function setup(app: App) {
  if (isProd() || isE2ETest()) { return; }
  app.config.errorHandler = (err, vm, info) => {
    showErrorOverlay(err);
    // eslint-disable-next-line no-console
    console.error(err, vm, info);
  };
  app.config.warnHandler = (msg, vm, trace) => {
    if (!isProd()
      // && ['recursive', 'property'].map((s) => msg.includes(s)).includes(true)
      && ![
        'Avoid app logic that relies on enumerating keys on a component instance. The keys will be empty in production mode to avoid performance overhead.',
        'To opt-in to the new behavior now, set',
        'Image failed to load!And failed src was',
        'Uncaught Error: T',
      ].map(s => msg.includes(s)).includes(true)
    ) {
      const errorObject = new Error(msg + trace);
      showErrorOverlay(errorObject);

      // eslint-disable-next-line no-console
      console.error(msg, vm, trace);
      return;
    }

    // eslint-disable-next-line no-console
    console.error(msg, vm, trace);
  };

  if (checkOverlayAvailable()) {
    window.addEventListener('error', showErrorOverlay);
    window.addEventListener('unhandledrejection', ({ reason }) => showErrorOverlay(reason));
  }
}

export default setup;
